import { ButtonType, ButtonWidget } from '@tableau/widgets';
import React from 'react';

import { getAppStore } from '~src/bootstrap/redux/store/AppStore';
import { Messages } from '~src/codegen/Localize';
import { imgPath } from '~src/commonInfra/utils/ImgUrl';

import { createNewConnectedApplication } from '../actions/ConnectedApplicationActions';

export const CreateConnectedApplicationAction = {
  title: () => 'New Connected Application',
  icon: imgPath('site_content_type_small.svg'),
  createReduxAction: createNewConnectedApplication,
  isDivider: false
};

export function newConnectedApplicationButton(): JSX.Element {
  const reduxAction = CreateConnectedApplicationAction.createReduxAction();
  const handleClick = () => getAppStore().dispatch(reduxAction);
  return (
    <ButtonWidget
      children={Messages.connectedApplicationNewConnectedApplicationButton()}
      buttonType={ButtonType.Outline}
      handleClick={handleClick}
      tb-test-id={'action-create-new-connected-application'}
      testId={'action-create-new-connected-application'}/>
  );
}
